import { Box } from "@mui/material";
import VideoHero from "./VideoHero";
import PartnersGrid from "./PartnersGrid";
import AwardsAndPrograms from "./AwardsAndPrograms";
import StrategicPartners from "./StrategicPartners";


export default function WhoWeAre() {
    return (
        <Box component="main" sx={{ bgcolor: "#0f1011" }}>
            <VideoHero />
            <PartnersGrid />
            <AwardsAndPrograms />
            <StrategicPartners />
        </Box>
    );
}